import React, { Suspense } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material';
import { IntlProvider } from 'react-intl';
import { theme } from './theme';
import { Experience } from './experiences/Experience';
import ErrorBoundary from './components/ErrorBoundary';
import { Spinner } from './components/Spinner';
import { AuthProvider } from './auth/context';
import createStore from './store';

export const store = createStore();

export default function App() {
  return (
    <IntlProvider locale={navigator.language}>
      <ThemeProvider theme={theme}>
        <ErrorBoundary>
          <Suspense fallback={<Spinner />}>
            <Provider store={store}>
              <AuthProvider>
                <BrowserRouter>
                  <Experience />
                </BrowserRouter>
              </AuthProvider>
            </Provider>
          </Suspense>
        </ErrorBoundary>
      </ThemeProvider>
    </IntlProvider>
  );
}
